import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

export const formatDate = (date, format = 'MM/DD/YYYY hh:mm:ss A') => {
  return dayjs(date).format(format)
}